import { useQuery, useSuspenseQuery } from '@tanstack/react-query'

import { internalApi } from '@/modules/api/request'

export const useOrganization = (organizationId: string) =>
  useSuspenseQuery({
    queryKey: [`/organizations/${organizationId}/`],
    queryFn: async () => await internalApi.organizations.getOrganizationByUuid({ organizationId }),
  })
